<!-- @format -->

<header>
	<button class="hamburger-btn" (click)="sidebarService.toggleSidebar()" type="button">
		<span class="hamburger-line"></span>
		<span class="hamburger-line"></span>
		<span class="hamburger-line"></span>
	</button>
	<div>
		<div class="notification-bell">
			<button class="bell-btn" (click)="toggleNotifications()" type="button" aria-label="Notifications">
				<img src="assets/bell-icon.svg" width="20" height="20" alt="Notifications" />
				<span *ngIf="unreadCount > 0" class="bell-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
			</button>
			<div *ngIf="isNotificationsOpen" class="notifications-panel">
				<div class="notifications-header">Notifications</div>
				<div *ngIf="notifications.length === 0" class="notifications-empty">You're all caught up.</div>
				<button *ngFor="let n of notifications" type="button"
					class="notification-item" [class.unread]="!n.isRead" (click)="openNotification(n)">
					<span class="notification-dot" *ngIf="!n.isRead"></span>
					<span class="notification-body">
						<span class="notification-title">{{ n.workflowName || 'Workflow' }}</span>
						<span class="notification-event">{{ n.eventType | titlecase }}</span>
					</span>
				</button>
			</div>
		</div>
		<div class="user-image">
			<span style="color: white;">{{ initial }}</span>
		</div>
		<div>
			<h4 class="user-name">{{ name }}</h4>
			<p class="user-role">{{ currentRole }}</p>
		</div>
		<button class="dropdown-trigger" (click)="toggleDropdown()" type="button">
			<img
			
			src="../../../assets/down-arrow.svg"
			width="16px"
			height="16px"
			alt="down-arrow" />
		</button>
	</div>
</header>
<div *ngIf="isToggleOpen" class="logout-container">
	<button (click)="setShowLogout(true)" class="logout-btn" type="button">
		<img src="../../../assets/logout-icon.svg" /> 
		<span>Log Out</span>
	</button>
</div>
<app-save-modal (onSave)="handleLogout()" *ngIf="dialogService.showModal" [actionButtonTitle]="'Log Out'" [subTitle]="'Are you sure you want to log out?'" [title]="'Log Out'">

</app-save-modal>